<mat-card-header class="flex align-items-center">
  <shared-title
    >{{
      this.data.type === 'Editar' ? 'Editar' : 'Crear'
    }}
    usuario</shared-title
  >
</mat-card-header>
<form [formGroup]="userForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <!-- Web -->

    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row pb-2">
      <shared-input
        class="w-full"
        [labelTitle]="'Nombre'"
        [control]="$any(userForm.get('first_name'))"
        type="text"
        onkeydown="return /[a-z, ]/i.test(event.key)" />
      <shared-input
        class="w-full"
        [labelTitle]="'Apellido'"
        [control]="$any(userForm.get('last_name'))"
        type="text"
        onkeydown="return /[a-z, ]/i.test(event.key)" />
    </div>

    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row pb-2">
      <shared-input
        class="w-full"
        [labelTitle]="'Usuario'"
        [control]="$any(userForm.get('user_name'))"
        type="text" />
    </div>

    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row pb-2">
      @if (this.data.type === 'Crear') {
        <div class="w-full">
          <shared-input
            class="w-full"
            [labelTitle]="'Contraseña'"
            [control]="$any(userForm.get('password'))"
            [type]="'password'" />
        </div>
      }
    </div>

    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row pb-2">
      <shared-input
        class="w-full"
        [labelTitle]="'Correo'"
        [control]="$any(userForm.get('email'))"
        [type]="'email'"
        [styleText]="'lowercasse'" />
      <shared-input
        class="w-full"
        [labelTitle]="'Correo secundario'"
        [control]="$any(userForm.get('secondEmail'))"
        [type]="'email'"
        [styleText]="'lowercasse'" />
    </div>

    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row pb-2">
      <shared-input
        class="w-full"
        [labelTitle]="'Dirección'"
        [control]="$any(userForm.get('address'))"
        [styleText]="'lowercasse'" />

      <div class="w-full">
        <shared-input
          class="w-full"
          [labelTitle]="'Teléfono'"
          [control]="$any(userForm.get('phone'))"
          type="text" />
      </div>
    </div>
    @if (this.data.data !== 'checkApp' && this.data.type !== 'Editar') {
      <div
        class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row pb-2">
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Roles</mat-label>
          <mat-select
            formControlName="role_id"
            (selectionChange)="whenRolesChange()"
            [(value)]="selectedRole">
            @for (item of Roles; track item) {
              <mat-option [value]="item.roleid">
                {{ item.name }}
              </mat-option>
            }
          </mat-select>
          @if (userForm.controls['role_id'].hasError('required')) {
            <mat-error>
              <small>Rol es <strong>requerido</strong> </small>
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
    @if (
      (isSysAdmin || this.bussinessWorker === 0) &&
      this.sysadminselect &&
      this.data.data.roleName !== 'SYSADMIN' &&
      this.data.data.roleName !== 'ACCESOS'
    ) {
      <mat-form-field class="w-full" appearance="outline">
        <mat-label>Empresa</mat-label>
        <mat-select
          formControlName="businessId"
          (selectionChange)="whenChangeBusiness()"
          [(value)]="selectedBussines">
          @for (item of Business; track item) {
            <mat-option [value]="item.idBusiness">
              {{ item.name }}
            </mat-option>
          }
        </mat-select>
        @if (userForm.controls['businessId'].hasError('required')) {
          <mat-error>
            <small>Empresa es <strong>requerida</strong> </small>
          </mat-error>
        }
      </mat-form-field>
    }

    <!-- Application -->

    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row pb-2">
      @if (
        this.data.data === 'checkApp' ||
        (this.data.type === 'Editar' &&
          (this.data.data.roleId === 4 || this.data.data.roleId === 11))
      ) {
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Edificio</mat-label>
          <mat-select formControlName="buildingId">
            @for (item of Buildings; track item) {
              <mat-option [value]="item.buildingid">
                {{ item.name }}
              </mat-option>
            }
          </mat-select>
          @if (userForm.controls['buildingId'].hasError('required')) {
            <mat-error>
              <small>Edificio es <strong>requerido</strong> </small>
            </mat-error>
          }
        </mat-form-field>
      }
      @if (
        this.data.data === 'checkApp' ||
        (this.data.type === 'Editar' &&
          (this.data.data.roleId === 4 || this.data.data.roleId === 11))
      ) {
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Grupo</mat-label>
          <mat-select formControlName="workerGroupId">
            <mat-option value="0">-- Por defecto --</mat-option>
            @for (item of Groups; track item) {
              <mat-option [value]="item.id">
                {{ item.name }}
              </mat-option>
            }
          </mat-select>
          @if (userForm.controls['workerGroupId'].hasError('required')) {
            <mat-error>
              <small>Grupo es <strong>requerido</strong> </small>
            </mat-error>
          }
        </mat-form-field>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="w-full gap-2 flex justify-content-evenly mb-3">
    <shared-button
      mat-dialog-close
      [icon]="'clear'"
      [typeBtn]="'button'"
      [color]="'warn'"
      >Cancelar
    </shared-button>

    <shared-button
      [disabled]="!userForm.valid"
      [icon]="'save_alt'"
      [typeBtn]="'submit'"
      [color]="'accent'"
      >Guardar</shared-button
    >
  </mat-dialog-actions>
</form>
